(function () {
  const parseRatePercent = (raw) => {
    const text = String(raw || '').trim();
    if (text === '') {
      return 0;
    }
    const normalized = text.replace(/%/g, '').replace(',', '.');
    const value = Number.parseFloat(normalized);
    if (!Number.isFinite(value)) {
      return 0;
    }
    return value;
  };

  const formatProductMoney = (cents) => {
    const amount = Math.round(Number(cents) || 0);
    const lira = Math.floor(amount / 100);
    const kurus = amount % 100;
    const str = String(lira);
    let formatted = '';
    let count = 0;

    for (let index = str.length - 1; index >= 0; index -= 1) {
      if (count > 0 && count % 3 === 0) {
        formatted = `${str.charAt(index)}.${formatted}`;
      } else {
        formatted = `${str.charAt(index)}${formatted}`;
      }
      count += 1;
    }

    if (kurus > 0) {
      const kurusString = kurus < 10 ? `0${kurus}` : String(kurus);
      formatted += `,${kurusString}`;
    }

    return `${formatted}\u00a0TL`;
  };

  const getWirePrice = (priceCents, discountPercent) => {
    const price = Number(priceCents) || 0;
    const discount = Number(discountPercent) || 0;
    const wirePrice = Math.round((price * (100 - discount)) / 100);
    return Math.round((wirePrice + 50) / 100) * 100;
  };

  const getWireSettings = (paymentRoot) => {
    if (paymentRoot) {
      const fromPayment = Number.parseInt(paymentRoot.dataset.wireDiscount, 10);
      if (Number.isFinite(fromPayment)) {
        return {
          discount: fromPayment,
          showWire: paymentRoot.dataset.showWirePrice !== 'false',
        };
      }
    }

    const priceRoot = document.querySelector('[data-product-price]');
    if (!priceRoot) {
      return { discount: 5, showWire: true };
    }

    return {
      discount: Number.parseInt(priceRoot.dataset.wireDiscount, 10) || 5,
      showWire: priceRoot.dataset.showWirePrice === 'true',
    };
  };

  const totalForPlan = (priceCents, ratePercent) => {
    const base = Number(priceCents) || 0;
    const rate = parseRatePercent(ratePercent);
    if (rate <= 0) {
      return base;
    }
    return Math.round(base * (1 + rate / 100));
  };

  const updatePaymentRoot = (root, priceCents, wirePriceCents) => {
    const cardEl = root.querySelector('[data-product-payment-card-price]');
    const wireEl = root.querySelector('[data-product-payment-wire-price]');
    const wireSettings = getWireSettings(root);

    if (cardEl) {
      cardEl.textContent = formatProductMoney(priceCents);
    }

    if (wireEl) {
      if (wireSettings.showWire) {
        const wireCents =
          wirePriceCents != null ? wirePriceCents : getWirePrice(priceCents, wireSettings.discount);
        wireEl.textContent = formatProductMoney(wireCents);
      } else {
        wireEl.textContent = formatProductMoney(priceCents);
      }
    }

    root.querySelectorAll('[data-payment-installment-row]').forEach((row) => {
      const count = Number.parseInt(row.dataset.installmentCount, 10);
      const rate = row.dataset.installmentRate || '';
      const total = totalForPlan(priceCents, rate);
      const monthly = count > 0 ? Math.round(total / count) : 0;

      const monthlyEl = row.querySelector('[data-payment-cell-monthly]');
      const totalEl = row.querySelector('[data-payment-cell-total]');

      if (monthlyEl) {
        monthlyEl.textContent = formatProductMoney(monthly);
      }

      if (totalEl) {
        totalEl.textContent = formatProductMoney(total);
      }
    });
  };

  const initPaymentRoot = (root) => {
    if (root.dataset.productPaymentInitialized === 'true') {
      return;
    }

    const initial = Number.parseInt(root.dataset.initialPriceCents, 10) || 0;
    const wireSettings = getWireSettings(root);
    updatePaymentRoot(
      root,
      initial,
      wireSettings.showWire ? getWirePrice(initial, wireSettings.discount) : initial
    );
    root.dataset.productPaymentInitialized = 'true';
  };

  const onVariantPrice = (event) => {
    const detail = event.detail || {};
    const priceCents = Number(detail.priceCents) || 0;
    let wirePriceCents = detail.wirePriceCents;

    document.querySelectorAll('[data-product-payment]').forEach((root) => {
      const wireSettings = getWireSettings(root);
      let resolvedWire = wirePriceCents;

      if (resolvedWire == null && wireSettings.showWire) {
        resolvedWire = getWirePrice(priceCents, wireSettings.discount);
      }

      updatePaymentRoot(root, priceCents, resolvedWire);
    });
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-product-payment]').forEach(initPaymentRoot);
  };

  document.addEventListener('joker:product-variant-price', onVariantPrice);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
